"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["BK"] = "BK";
    Brand["LTW"] = "LTW";
    Brand["PLK"] = "PLK";
    Brand["TH"] = "TH";
    Brand["FHS"] = "FHS";
})(Brand || (exports.Brand = Brand = {}));
//# sourceMappingURL=brand.js.map